const $ = require('jquery')
const _ = require('lodash')

const editableDirective = function(Vue) {
  Vue.directive('editable', {
    bind: function(el, binding, vnode) {
          let expr = binding.value

          let $el = $(el)

          console.log('editable $el :', $el.height(), expr)

          let $editEl = $(document.createElement('div'))
          $editEl
            .text('$$')
            .addClass('editable-mark-button')

          $el.after($editEl)
      }
  })
}

export { editableDirective }



// WEBPACK FOOTER //
// ./src/directives/editable-directive.js